import capitalize from 'lodash/capitalize';

/**
 * Capitalizes the first letter of each word in a string.
 */
export function capitalizeWords(str: string, separator = ' '): string {
  return str.split(separator).map(capitalize).join(separator);
}
